import React, { useState } from "react";
import Dialog from "../../../ui/widgets/dialog";
import { useMessageSource } from "react-message-source";
import Typography from "../../../ui/widgets/typography";
import Button from "../../../ui/widgets/button";
import { CancelReasonModel } from "../components/cancel-dialog/types";
import ApplicationCanceledDialog from "../components/cancel-dialog/application-canceled";
import { Product } from "../../../context/product-context/product";

interface DisabledProductDialogProps {
  cancelApplicationCallback: (values: CancelReasonModel) => void;
  product: Product;
}

export const DisabledProductDialog = ({
  product,
  cancelApplicationCallback,
}: DisabledProductDialogProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const [cancelConfirmationShown, setCancelConfirmationShown] =
    useState<boolean>(false);
  const [cancelDialogActive, setCancelDialogActive] = useState<boolean>(true);

  const isCreditSuisseProduct =
    product.family.name === "CS_DUO" || product.family.name === "CS_SINGLE";

  const cancelReasonModel: CancelReasonModel = {
    cancelReasonOption: "PRODUCT_DISABLED",
    otherReason: "",
  };

  if (cancelConfirmationShown) {
    return (
      <ApplicationCanceledDialog
        onDismiss={() => {
          setCancelConfirmationShown(false);
          setCancelDialogActive(false);
          window.location.reload();
        }}
      />
    );
  }

  return (
    <Dialog disableEscapeKeyDown={true} open={cancelDialogActive} maxWidth="lg">
      <Typography variant="h2" className="scd-container-base">
        {getMessage("DisabledProductDialog.title")}
      </Typography>
      <Typography variant="body1" className="scd-container-base">
        {isCreditSuisseProduct
          ? getMessage("DisabledProductDialog.credit-suisse.text")
          : getMessage("DisabledProductDialog.text")}
      </Typography>
      <div className="scd-dialog-footer">
        <Button
          onClick={() => {
            cancelApplicationCallback(cancelReasonModel);
            setCancelConfirmationShown(true);
          }}
          kind="primary"
        >
          {getMessage("Onboarding.continue")}
        </Button>
      </div>
    </Dialog>
  );
};
